// src/theme.ts
/* ===========================================================================================================================*/
/* =========このシステムの基本的な色やコンポーネントをまとめているファイルです。テーマを変更したい場合はここを編集してください。========*/
/* ===========================================================================================================================*/

import { createTheme } from '@mui/material/styles';
import type {} from '@mui/x-data-grid-pro/themeAugmentation';// DataGridProのテーマ型拡張を読み込む

/*　各ページで　themeをインポートして、ThemeProviderで囲むことでﾃｰﾏが適用されます。*/
      const theme = createTheme({

        // カラーパレットの定義*************************************************
          palette: {
          primary: { main: '#C5E763', 
                         // #98bc2e  modalで使用
                    light: '#00bfc5',  //ボタンなどに使用
                    dark: '#2acfbb',  contrastText: '#fff' },
          secondary: { main: '#3A414C',
                      contrastText: '#fff' },
          warning: { main: '#FFC107', 
                    contrastText: '#000' },
          error: { main: '#ff8579' },
          text: { primary: '#fff', 
                  secondary: '#3c4158' },

          // ダイアログ/画面ベースの背景
          background: {
             default: '#2D2C3A',         // 画面全体
               paper: '#2D2C3A',         // ダイアログなどのPaper
            },
             divider: 'rgba(217, 217, 217, 0.12)',
        },


        // 画面に配置する基本的なコンポーネントのスタイルを定義**********************

          components: {
            
            /* ===================== TextField のデフォルト variant を outlined に統一 ===================== */
            MuiTextField: {
              defaultProps: {
                variant: 'outlined',
              },
            },

            /* ===================== AppBar（画面最上部の帯） ===================== */
            MuiAppBar: {
              defaultProps: {
                color: 'primary',
                elevation: 2,
              },
            },

            /* ===================== Dialog ===================== */
            MuiDialog: {
              styleOverrides: {
                paper: {
                  borderRadius: 12,
                  backgroundColor: '#2D2C3A',  // あなたがPaperPropsで指定した色を既定化
                  color: '#fff',
                },
              },
            },

            /* ===================== DialogTitle ===================== */
            MuiDialogTitle: {
              styleOverrides: {
                root: {
                  position: 'sticky',
                  top: 0,
                  zIndex: 1,
                  backgroundColor: '#98bc2e',  
                  color: '#fff',
                },
              },
            },

            /* ===================== 通常Boxの「帯」をテーマ化したい場合 =====================
              Box自体はコンポーネントではないので、ここでは直接上書きできません。
              → 代わりに、共通のクラスを使う方針にします（下にサンプルあり）
            ============================================================================ */

            /* ===================== Button ===================== */
            MuiButton: {
              defaultProps: {
                variant: 'contained',
                color: 'primary',
              },
              styleOverrides: {
                root: {
                  borderRadius: 8,
                  textTransform: 'none',
                  fontWeight: 600,
                },

                // contained + primary の既定文字色を変更（毎回 sx を書かなくて済む）
                containedPrimary: {
                  color: '#1F2530',               // = palette.primary.contrastText に揃えるなら 'primary.contrastText'
                  '&:hover': { color: '#ffffff' },
                  '&.Mui-disabled': {
                    color: 'rgba(31,37,48,0.60)',
                    backgroundColor: 'rgba(197,231,99,0.60)',
                  },
                },

                // outlined + primary（キャンセルボタン用の雰囲気）
                outlinedPrimary: {
                  borderColor: 'rgba(197,231,99,0.6)',
                  color: '#C5E763',
                  '&:hover': {
                    borderColor: '#C5E763',
                    backgroundColor: 'rgba(197,231,99,0.08)',
                  },
                },
              },
            },

            /* ===================== TextField（= OutlinedInput + Label + HelperText） ===================== */
            MuiOutlinedInput: {
              styleOverrides: {
                root: {
                  borderRadius: 10,
                  backgroundColor: '#1F2530',
                  color: 'white',
                  transition: 'background-color .2s ease, box-shadow .2s ease',

                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(129, 158, 191, 0.56)',
                  },

                  '&.Mui-focused': {
                    backgroundColor: '#222838',
                    boxShadow:
                      'inset 0 1px 0 rgba(255,255,255,0.06), 0 0 0 2px rgba(197,231,99,0.20)',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'error.main',
                    },
                  },

                  '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(211,47,47,0.8)',
                  },
                  '&.Mui-error.Mui-focused': {
                    boxShadow:
                      'inset 0 1px 0 rgba(255,255,255,0.06), 0 0 0 2px rgba(211,47,47,0.20)',
                  },
                

                  // disabled のときは hover でも枠線色を変えない（固定）
                  '&.Mui-disabled:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(217, 217, 217, 0.12)',
                  },
                  // disabled の通常時も枠線色を固定
                  '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(217, 217, 217, 0.12)',
                  },

                },
                
                notchedOutline: {
                  border: '1px solid rgba(217, 217, 217, 0.12)',
                },
                input: {
                  '::placeholder': { color: '#9FB0C0', opacity: 1 },
                  // padding: '12px 16px', // 入力域を大きくしたい時はコメント解除
                  
                '&.Mui-disabled': {
                  opacity: 1,
                  WebkitTextFillColor: '#787a73',
                
                },

                },
              },
            },
                MuiInputLabel: {
                  styleOverrides: {
                    root: {
                      color: "#858fa3",
                      "&.Mui-focused": {
                        color: "#C5E763",
                      },
                    },
                    asterisk: {
                      color: "#ff8579",
                    },
                  },
              
            },
                MuiFormHelperText: {
                  styleOverrides: {
                    root: {
                      marginLeft: 0,
                      color: "rgba(232,238,245,0.75)",
                      "&.Mui-error": {
                        color: "#ff8579",
                      },
                    },
                  },
                },

            /* ===================== DataGridPro（@mui/x-data-grid-pro） ===================== */
            // ※ バージョンによって多少差があります。効かない箇所は個別のsxで補完してください。
            MuiDataGrid: {
              styleOverrides: {
                columnHeaders: {
                  backgroundColor: '#1F1D30',
                  color: '#fff',
                },
                row: {
                  '&:hover': { backgroundColor: 'rgba(197,231,99,0.06)' },
                },
                cell: {
                  borderBottom: '1px solid rgba(217, 217, 217, 0.12)',
                },
            

              },
            },

            /* ===================== Snackbar / Alert（任意） ===================== */
            MuiAlert: {
              styleOverrides: {
                standardSuccess: {
                  backgroundColor: 'rgba(152, 188, 46, 0.12)',
                  color: '#98bc2e',
                },
                standardWarning: {
                  backgroundColor: 'rgba(255, 193, 7, 0.12)',
                  color: '#FFC107',
                },
              },
            
            },

            
            
  },
});

export default theme;